"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HierarchyTypeUtilFactory = void 0;
var types_1 = require("../types");
var NonMgrHierarchyUtil_1 = __importDefault(require("./NonMgrHierarchyUtil"));
var PersonHierarchyUtil_1 = __importDefault(require("./PersonHierarchyUtil"));
var PositionHierarchyUtil_1 = __importDefault(require("./PositionHierarchyUtil"));
exports.HierarchyTypeUtilFactory = {
    getHierarchyTypeUtil: function (hierarchyType) {
        switch (hierarchyType) {
            case types_1.HierarchyType.Person:
                return new PersonHierarchyUtil_1.default();
            case types_1.HierarchyType.Position:
                return new PositionHierarchyUtil_1.default();
            case types_1.HierarchyType.NonManagerialNotSpecified:
            case types_1.HierarchyType.BusinessUnit:
            case types_1.HierarchyType.Location:
            case types_1.HierarchyType.Function:
            case types_1.HierarchyType.Hybrid:
            case types_1.HierarchyType.Other:
                return new NonMgrHierarchyUtil_1.default();
            default:
                throw Error('Invalid HierarchyType');
        }
    },
};
